/**
 * Configuration Supabase pour SSO
 *
 * Stockage : sessionStorage (scoped à l'onglet, effacé à la fermeture du navigateur)
 * L'auth principale pour les appels API utilise les cookies HttpOnly gérés par le backend.
 */

import { createClient } from '@supabase/supabase-js'

const supabaseUrl     = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    '[Supabase] Variables manquantes : REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_ANON_KEY requises.'
  )
}

// Adaptateur sessionStorage : mieux que localStorage (effacé à la fermeture de l'onglet)
// Le vrai token sécurisé est dans le cookie HttpOnly côté backend
const sessionStorageAdapter = {
  getItem:    (key) => sessionStorage.getItem(key),
  setItem:    (key, val) => sessionStorage.setItem(key, val),
  removeItem: (key) => sessionStorage.removeItem(key),
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    persistSession:   true,
    autoRefreshToken: true,
    storage:          sessionStorageAdapter,
  },
})
